import { Grid } from '@mui/material';
import { RoutalPalette, VSpacer } from '@nx-smartmonkey/ui';
import { useNavigate, useSearchParams } from 'react-router-dom';
import styled from 'styled-components';

import InfoIcon from '../../../assets/img/info-icon.svg';
import * as routing from '../../../constants/Routing';
import { PlanStatus } from '../../../domain/plan/PlanStatus';
import { useRetrieveActiveProject } from '../../../hooks/project/useRetrieveActiveProject';
import { useRetrieveSupportDocs } from '../../../hooks/support-docs/useRetrieveSupportDocs';
import { useRetrieveUser } from '../../../hooks/user/useRetrieveUser';
import Text from '../../../react-components/Text';
import { CreatePlan } from './CreatePlan';

const PlannerPlansHeaderContainer = styled(Grid)`
  width: 100%;
  padding: 20px;
  background-color: ${RoutalPalette.white};
  border-bottom: 1px solid ${RoutalPalette.neutral10};
`;

export const PlannerPlansHeader = () => {
  const navigate = useNavigate();
  const { data: activeProject } = useRetrieveActiveProject();
  const [searchParams] = useSearchParams();
  const { retrieveDoc } = useRetrieveSupportDocs();
  const filterStatus = searchParams.has(`filterStatus`) ? (searchParams.get(`filterStatus`) as PlanStatus) : undefined;
  const { data: user } = useRetrieveUser();

  const getTitle = () => {
    switch (filterStatus) {
      case `planning`:
        return `planner.plans.planning`;
      case `in_progress`:
        return `planner.plans.in_progress`;
      case `finished`:
        return `planner.plans.finished`;
      case `draft`:
        return `planner.plans.draft`;
      default:
        return `planner.plans.all_the_plans`;
    }
  };

  return (
    <PlannerPlansHeaderContainer container alignContent="space-between" justifyContent="center" wrap="nowrap">
      <Grid container direction="column">
        <Text variant="h5" intlId={getTitle()} />

        <VSpacer small />

        <Grid container direction="row">
          <Text
            variant="button"
            onClick={() => window.open(retrieveDoc({ supportPage: `plan`, language: user?.language.value }), `_blank`)}
          >
            <Grid container alignItems="center">
              <img alt="" src={InfoIcon} width="14px" draggable="false" />

              <div style={{ width: `6px` }} />

              <Text tagName="span" variant="button" intlId={`planner.plans.info`} />
            </Grid>
          </Text>

          {/* <HSpacer small />

          <Text variant="button" onClick={() => window.open(`https://www.youtube.com/watch?v=-XjdgAM7PYs`, `_blank`)}>
            <Grid container alignItems="center">
              <img alt="" src={VideosIconSvg} />

              <div style={{ width: `4px` }} />

              <Text tagName="span" variant="button" intlId="watch_video" />
            </Grid>
          </Text> */}
        </Grid>
      </Grid>

      <Grid container direction="row" wrap="nowrap" alignItems="center" justifyContent="flex-end">
        <Grid item>
          <CreatePlan
            buttonProps={{
              id: `create_new_plan`,
            }}
            handleCreatePlan={(newPlanId: string) => {
              navigate(
                routing.PLANNER.PLAN_DETAILS.OVERVIEW.replace(`:projectId`, activeProject!.id).replace(
                  `:planId`,
                  newPlanId
                )
              );
            }}
          />
        </Grid>
      </Grid>
    </PlannerPlansHeaderContainer>
  );
};
